export default {"src":"/_next/static/media/error.c596d272.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};